// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/DashBoard/AdminOrganizations/OrganizationList/OrganizationList.css
// module id = 692
// module chunks = 0